var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import localForage from 'localforage';
import nemWrapper from './nemWrapper';
var walletModel = /** @class */ (function () {
    function walletModel() {
        var _this = this;
        this.balance = 0;
        this.address = '';
        this.publicKey = '';
        this.privateKey = '';
        this.nem = new nemWrapper();
        // クラス生成時にローカルストレージからアカウント情報を取得
        this.load()
            .then(function (result) {
            console.log(result);
            // 無ければアカウントを作成します
            if (result === null) {
                _this.nem.createAccount()
                    .then(function (wallet) {
                    _this.address = wallet.address;
                    _this.privateKey = wallet.privateKey;
                    _this.save();
                }).catch(function (error) {
                    console.error(error);
                });
            }
            else {
                // あればNEMの残高を取得します
                _this.getAccount();
            }
        }).catch(function (error) {
            console.error(error);
        });
    }
    // ローカルストレージへ保存.
    walletModel.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var key, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = 'easy-wallet';
                        return [4 /*yield*/, localForage.setItem(key, this.toJSON())];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // ローカルストレージから取得.
    walletModel.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var key, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = 'easy-wallet';
                        return [4 /*yield*/, localForage.getItem(key)];
                    case 1:
                        result = _a.sent();
                        if (result !== null) {
                            this.address = result.address;
                            this.privateKey = result.privateKey;
                            this.publicKey = result.publicKey;
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // ローカルストレージから削除.
    walletModel.prototype.remove = function () {
        return __awaiter(this, void 0, void 0, function () {
            var key, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = 'easy-wallet';
                        return [4 /*yield*/, localForage.removeItem(key)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // アカウント情報を取得.
    walletModel.prototype.getAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nem.getAccount(this.address)];
                    case 1:
                        result = _a.sent();
                        this.balance = result.account.balance / this.nem.getNemDivisibility();
                        if (result.account.publicKey !== null) {
                            this.publicKey = result.account.publicKey;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // 送金(NEM)
    walletModel.prototype.sendNem = function (address, amount, message) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nem.sendNem(address, this.privateKey, amount, message)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    walletModel.prototype.toJSON = function () {
        return {
            address: this.address,
            privateKey: this.privateKey,
            publicKey: this.publicKey
        };
    };
    return walletModel;
}());
export default walletModel;



//////////////////
// WEBPACK FOOTER
// ./src/ts/walletModel.ts
// module id = 536
// module chunks = 1